import React from 'react';
import { useUser } from '../store/hooks/useUser';
import { useAppContext } from '../contexts/AppContext';
import { Constants } from '../constants';
import { refreshToken } from '../services/login.service';

const SessionManager = () => {
    const { showLoader, hideLoader, showToaster, hideToaster, isLoading } = useAppContext();
    const { user, updateUser } = useUser();

    const handleConfirmSession = async () => {
        try {
            showLoader();
            const response = await refreshToken();
            if (response) {
                updateUser({ refreshTokenWarningAction: 'REFRESH', timeToLogout: Constants.SESSION_TIMEOUT / 1000 / 60 });
            } else {
                showToaster(response.message || 'Something went wrong', 'error');
                setTimeout(() => {
                    hideToaster();
                }, Constants.TOASTER_TIMEOUT);
                updateUser({ refreshTokenWarningAction: 'SHOW_WARNING' });
            }
        } catch (error) {
            console.log(error);
            showToaster(error.message, 'error');
            setTimeout(() => {
                hideToaster();
            }, Constants.TOASTER_TIMEOUT);
        } finally {
            hideLoader();
        }
    };

    const handleCancelSession = () => {
        updateUser({ refreshTokenWarningAction: 'CANCEL' });
    };

    if (user.refreshTokenWarningAction != 'SHOW_WARNING' || isLoading || !user.isLoggedIn) return null;

    return (
        <>
            <div class="modal-backdrop fade show"></div>
            <div className={`modal show d-block fade`}>
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body signout-modal">
                            <h3 className="pt-4">
                                Your session is about to expire. Do you want to extend your session?
                            </h3>
                        </div>
                        <div className="modal-footer la-app-modal-footer">
                            <button type="button" className="lm-button2" onClick={handleCancelSession}>Cancel</button>
                            <button type="button" className="lm-button1" onClick={handleConfirmSession}>Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SessionManager;